<div class="container">
    <div class="body-area">
        <div tid="name" class="tam-form-field"
            [ngClass]="{'has-error': needValidControl.name &&(!config.taskDefinition.name||(config.taskDefinition.name&&config.taskDefinition.name.length>64))}">
            <div class="tam-form-label">Name&nbsp;<span class="required-field">*</span></div>
            <input class="tam-textbox" type="text" [(ngModel)]="config.taskDefinition.name" (input)="onChangeName()" />
            <div class="tam-form-help" *ngIf="needValidControl.name && !config.taskDefinition.name">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="nameDuplicated">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
            <div class="tam-form-help"
                *ngIf="needValidControl.name && config.taskDefinition.name&&config.taskDefinition.name.length>64">
                {{'general.name_exceed_maximum' | stringLiterals: '64'}}
            </div>
        </div>
        <div tid="description" class="tam-form-field">
            <div class="tam-form-label">{{'general.description' | stringLiterals}}</div>
            <textarea class="tam-textbox fixed-size-textarea" [(ngModel)]="config.taskDefinition.description"
                maxlength="1024" (input)="onChangeDescription()"></textarea>
        </div>
        <div class="tam-form-field">
            <div class="tam-form-label">{{'workflow.assign_to' | stringLiterals}}&nbsp;<span
                    class="required-field">*</span></div>
        </div>
        <div class="tam-form-field assignee-type" tid="assign_to">
            <label tam-checkbox class="label-item" (click)="onDynamicAssigneeCheckedChange()"
                tid="dynamicAssignee_trigger" [(ngModel)]="assigneeType.isDynamicAssigneeChecked"></label>
            <div class="assignee-body secondary-label">
                <div class="assignee-row">
                    <label class="item">{{'workflow.assign_to_users_who_are' | stringLiterals}} &nbsp;</label>
                    <tam-single-select-dropdown-filter [dropdownConfig]="relationshipTypeConfig">
                        <ng-template #customContent>
                            <div class="selected-item">
                                <a (click)="onRelationshipTypeItemClick($event)">{{relationshipTypeLinkLabel}}</a>
                            </div>
                        </ng-template>
                    </tam-single-select-dropdown-filter>
                    <label class="item"> &nbsp;{{'workflow.of' | stringLiterals}} &nbsp;</label>
                    <tam-single-select-dropdown-filter [dropdownConfig]="frmEntityControlConfig"
                        [freezingItemsConfig]="freezingEntityCtrlCfg">
                        <ng-template #customContent>
                            <div class="selected-item">
                                <a (click)="onFrmEntityControlItemClick($event)">{{entityLinkLabel}}</a>
                            </div>
                        </ng-template>
                    </tam-single-select-dropdown-filter>
                </div>
            </div>
        </div>
        <div class="tam-form-field assignee-type" tid="assign_to">
            <label tam-checkbox class="label-item" (click)="onStaticAssigneeCheckedChange()"
                tid="staticAssignee_trigger" [(ngModel)]="assigneeType.isStaticAssigneeChecked"></label>
            <div class="assignee-body secondary-label">
                <div class="assignee-row">
                    <label class="item">{{'workflow.assign_to_static_list' | stringLiterals}} &nbsp;</label>
                    <multi-sel-dropdown-filter class="control-content" [dropdownConfig]='dropdownConfig'>
                        <ng-template #multiCustomContent>
                            <div class="selected-item text-ellipsis" (click)='onClickSource($event)'>{{sourceName}}
                            </div>
                        </ng-template>
                    </multi-sel-dropdown-filter>
                </div>
            </div>
        </div>
        <div class="tam-form-help invalid-msg" *ngIf="isErrorOccured">
            {{assigneeOptionErrorMessage}}
        </div>
        <br>
        <div tid="stage" class="tam-form-field"
            [ngClass]="{'has-error':needValidControl.stage && !config.taskDefinition.stage}">
            <div class="tam-form-label">Stage&nbsp;<span class="required-field">*</span></div>
            <kendo-combobox #kendoc class="tam-textbox" [popupSettings]="{appendTo: 'component'}" [data]="stageData"
                [textField]="'name'" [valueField]="'id'" [filterable]="true" [listHeight]="140"
                [(ngModel)]="config.taskDefinition.stage" (valueChange)="onChangeStage($event)" (focus)="focusStage()"
                (filterChange)="filterStage($event)">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <div class="one-stage-item">
                        <span class="item-text text-ellipsis">{{dataItem.name}}</span>
                        <span class="item-icon" *ngIf="dataItem.id" (click)="deleteStageItem($event, dataItem)">
                            <smart-icon name="close"></smart-icon>
                        </span>
                    </div>
                </ng-template>
                <ng-template kendoDropDownListNoDataTemplate>
                    &nbsp;&nbsp;&nbsp;{{'workflow.create_stage' | stringLiterals}}
                </ng-template>
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="needValidControl.stage && !config.taskDefinition.stage">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
    </div>
</div>